export const isUndefinedOrNull = (value?: unknown | null): boolean => {
  return value === undefined || value === null;
};

// method that will take 2 arguments, if main argument is undefined or null, it will return the second argument
export const getValueOrDefault = <T>(value: T | undefined | null, defaultValue: T): T => {
  return isUndefinedOrNull(value) ? defaultValue : value;
};


export const generateRandomAlphaNumericId = (): string => {
  return Math.floor(Math.random() * 0xffff)
    .toString(16)
    .padStart(4, '0');
}